export default __webpack_public_path__ + "d75205a830b31e4a3f3b23f1296af75a.svg";